import {
  METADATA_FORM_RESOURCE_TYPE,
  TEMPLATE_GOVERNANCE_TAG_RESOURCE_TYPE,
  TEMPLATE_GROUP_RESOURCE_TYPE,
  TEMPLATE_WORKSPACE_RESOURCE_TYPE,
} from 'src/commons/constants';

export enum ResourceType {
  LF_CATALOG = 'lfCatalog',
  LF_DATABASE = 'lfDatabase',
  LF_TABLE = 'lfTable',
  LF_FGAP = 'lfFGAP',
  LF_TAG = 'lfTag',
  REDSHIFT_CATALOG = 'redshiftCatalog',
  REDSHIFT_DATABASE = 'redshiftDatabase',
  REDSHIFT_SCHEMA = 'redshiftSchema',
  REDSHIFT_TABLE = 'redshiftTable',
  REDSHIFT_FGAP = 'redshiftFGAP',
  REDSHIFT_TAG = 'redshiftTag',
  CATALOG = 'catalog',
  DATABASE = 'database',
  SCHEMA = 'schema',
  TABLE = 'table',
  METADATA_FORM = 'metadataForm',
  GROUP = 'group',
  WORKSPACE = 'workspace',
  GOVERNANCE_TAG = 'governanceTag',
}

export const resourceTypeOptions = (
  isWorkspace: boolean,
  disableGroupAndWorkspaceSelection: boolean,
  disableTagSelection: boolean,
  disableMetadataFormSelection: boolean,
  disableCatalogSelection: boolean = false,
  disableGovernanceTagSelection: boolean = true,
  disableFgaSelection: boolean = false,
  disableRedshiftSelection: boolean = false,
) => {
  const optionalGovernanceTagOption = disableGovernanceTagSelection
    ? []
    : [{ value: ResourceType.GOVERNANCE_TAG, label: TEMPLATE_GOVERNANCE_TAG_RESOURCE_TYPE }];
  const optionalGroupOption = disableGroupAndWorkspaceSelection
    ? []
    : [{ value: ResourceType.GROUP, label: TEMPLATE_GROUP_RESOURCE_TYPE }];
  const optionalWorkspaceOption = disableGroupAndWorkspaceSelection
    ? []
    : [{ value: ResourceType.WORKSPACE, label: TEMPLATE_WORKSPACE_RESOURCE_TYPE }];
  // advisories does not support tags yet.
  const optionalTagsOption = disableTagSelection
    ? []
    : [
        { value: ResourceType.LF_TAG, label: 'Lake Formation Tag' },
        { value: ResourceType.REDSHIFT_TAG, label: 'Redshift Tag' },
      ];
  const optionalMetadataFormOption = disableMetadataFormSelection
    ? []
    : [{ value: ResourceType.METADATA_FORM, label: METADATA_FORM_RESOURCE_TYPE }];
  const optionalLFCatalogOption = disableCatalogSelection
    ? []
    : [{ value: ResourceType.LF_CATALOG, label: 'Lake Formation Catalog' }];
  const optionalLFFgapOption = disableFgaSelection
    ? []
    : [{ value: ResourceType.LF_FGAP, label: 'Lake Formation Fine Grained Access Policy' }];
  const optionalRedshiftCatalogOption =
    disableRedshiftSelection || disableCatalogSelection
      ? []
      : [{ value: ResourceType.REDSHIFT_CATALOG, label: 'Redshift Catalog' }];
  const optionalRedshiftDatabaseOption = disableRedshiftSelection
    ? []
    : [{ value: ResourceType.REDSHIFT_DATABASE, label: 'Redshift Database' }];
  const optionalRedshiftSchemaOption = disableRedshiftSelection
    ? []
    : [{ value: ResourceType.REDSHIFT_SCHEMA, label: 'Redshift Schema' }];
  const optionalRedshiftTableOption = disableRedshiftSelection
    ? []
    : [{ value: ResourceType.REDSHIFT_TABLE, label: 'Redshift Table' }];
  const optionalRedshiftFgapOption =
    disableRedshiftSelection || disableFgaSelection
      ? []
      : [{ value: ResourceType.REDSHIFT_FGAP, label: 'Redshift Fine Grained Access Policy' }];
  const resourceTypesWorkspace = [
    ...optionalGovernanceTagOption,
    ...optionalWorkspaceOption,
    ...optionalTagsOption,
    ...optionalMetadataFormOption,
    ...optionalLFCatalogOption,
    { value: ResourceType.LF_DATABASE, label: 'Lake Formation Database' },
    { value: ResourceType.LF_TABLE, label: 'Lake Formation Table' },
    ...optionalLFFgapOption,
    ...optionalRedshiftCatalogOption,
    ...optionalRedshiftDatabaseOption,
    ...optionalRedshiftSchemaOption,
    ...optionalRedshiftTableOption,
    ...optionalRedshiftFgapOption,
  ];
  const resourceTypesGroup = [
    ...optionalGovernanceTagOption,
    ...optionalGroupOption,
    ...optionalWorkspaceOption,
    ...optionalMetadataFormOption,
    ...optionalLFCatalogOption,
    { value: ResourceType.LF_DATABASE, label: 'Lake Formation Database' },
    { value: ResourceType.LF_TABLE, label: 'Lake Formation Table' },
  ];
  return isWorkspace ? resourceTypesWorkspace : resourceTypesGroup;
};

export const resourceTypeOptionsForSearch = (isWorkspace: boolean, disableCatalogSelection: boolean = false) => {
  const optionalSchemaOption = isWorkspace ? [{ value: ResourceType.SCHEMA, label: 'Schema' }] : [];
  const optionalCatalogOption = disableCatalogSelection ? [] : [{ value: ResourceType.CATALOG, label: 'Catalog' }];
  const resourceTypes = [
    ...optionalSchemaOption,
    ...optionalCatalogOption,
    { value: ResourceType.DATABASE, label: 'Database' },
    { value: ResourceType.TABLE, label: 'Table' },
  ];
  return resourceTypes;
};
